import script from "./Treatment.vue?vue&type=script&setup=true&lang=js"
export * from "./Treatment.vue?vue&type=script&setup=true&lang=js"

import "./Treatment.vue?vue&type=style&index=0&id=6d160c92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d160c92"]])

export default __exports__